import { createContext, useContext } from 'react';
import type { MouseEvent } from 'react';

export interface LoginContext {
  doLogin: (event?: MouseEvent) => void;
}

export const loginContext = createContext<LoginContext | undefined>(undefined);

export const { Provider } = loginContext;

export const useLogin = () => {
  const context = useContext(loginContext);

  if (context === undefined) {
    throw new Error('Value for `loginContext` must be set.');
  }

  return context;
};
